var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCostReduction = function SvgCostReduction(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6D5E",
    d: "M12.804 25.598a6.402 6.402 0 1 1-12.804 0 6.402 6.402 0 0 1 12.804 0m-.807 0a5.595 5.595 0 1 0-11.19 0 5.595 5.595 0 0 0 11.19 0M32 6.402a6.402 6.402 0 1 1-12.804 0 6.402 6.402 0 0 1 12.804 0m-.807 0a5.595 5.595 0 1 0-11.19 0 5.595 5.595 0 0 0 11.19 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0D5284",
    d: "m31.996 19.545.004.054v11.998l-.002.037-.009.055-.01.036-.031.07-.03.044-.036.043a.4.4 0 0 1-.06.049l-.05.03-.047.018-.074.017-.054.004H19.599a.403.403 0 0 1-.055-.803l.055-.004h11.024L.118.689a.403.403 0 0 1 .525-.61L.69.12l30.504 30.504V19.599c0-.204.152-.373.349-.4l.055-.003c.204 0 .373.152.4.348"
  })));
};
export default SvgCostReduction;